<template>
  <div class="webcardloginMain_012">
    <div class="list_card_login_mine_012" >
    <!--   虎卡包列表 -->
      <ul v-if="tigerList.length">
        <li v-for="(item, index) in tigerList" :key="item.id"  @click="cardLogin(item.cardrights,index)">
          <div class="list_card_left" v-if="cityLogo != ''"><img :src="cityLogo"></div>
          <div class="list_card_left" v-else><img src="@/assets/img/images/imgT.jpg" /></div>
          <div class="list_card_right">
            <h3>{{item.cardname}}</h3>
            <p>点击使用</p>
          </div>
        </li>
      </ul>
      <div class="center_box_list" v-if="!tigerList.length">
        没找到卡，请您点击下方绑卡哦~ 
      </div>
        
      <div class="webbottomheight"></div>
    </div>

    <div class="webbottom">
      <div class="item1" @click="cardBind">
        <p>绑定新卡</p>
      </div>
    </div>
  </div>
</template>
<script>
  import * as api from "@/api";
  import JmmToast from '@/components/JmmToast'
  import wx from "weixin-js-sdk";

  export default {
    name: "tigerCardLoginList",
    data() {
      return {
        token: "jjcimpilpgejfeehkdinjlbgabbgchhe",
        sign: "",   // 签名
        arr1: '',        // 用来判断积分卡的长度
        tigerList: [],    // 虎卡列表
        mobile: "",        // 手机号 判断有没有
        userId: '',         // 用户的id
        openId: '',         // 用户的openid
        appid: "",
        unionid:'',
        channel: '',        // 判断渠道ID
        // code: '',         // 获取到的code
        cityLogo: "",   // 城市logo
        displayType: "",   // 账户显示色调
        merchantId: '',
        stateId: ''
      };
    },
    
    created() {
      this.merchantId = this.$route.query.merchantId;
      this.stateId = this.$route.query.state;
      if(null != this.merchantId && undefined != this.merchantId && "merchantId" != this.merchantId){
        localStorage.setItem('cityMerchantId', this.merchantId);
      } else if(null != this.stateId && undefined != this.stateId && "merchantId" != this.stateId){
        this.merchantId = this.stateId;
        localStorage.setItem('cityMerchantId', this.merchantId);
      } else {
        localStorage.setItem('cityMerchantId', "");
      }
      this.cityLogo = localStorage.getItem("cityLogo");
      this.channel = this.$route.query.channel 
      //判断渠道ID
      if(null == this.channel || undefined == this.channel){
        this.channel = '';
      }
    },
    mounted () {
      this.getwebAppId()
    },
    components: { JmmToast },
    methods: {
        //  1 code地址
        getUrlCode() { // 截取url中的code方法
            var url = location.search
            var theRequest = new Object()
            if (url.indexOf("?") != -1) {
                var str = url.substr(1)
                var strs = str.split("&")
                for(var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
                }
            }
            return theRequest
        },
        // 获取城市appId
        async getwebAppId(){
          try {
            let info = {}
            const res = await api.user.getwebAppId(info)
            if (res.code == "000000") {
              this.appid = res.data.appId;
              this.cityLogo = res.data.logo;
              this.displayType = res.data.displayType;
              if(this.cityLogo == null || this.cityLogo == undefined){
                this.cityLogo = "";
              }
              localStorage.setItem('cityLogo', this.cityLogo);
              localStorage.setItem('displayType', this.displayType);
              this.getCode();
            } else {
              this.getCode();
            }
          } catch (err) {
            this.getCode();
            console.log(err)
          }      
        },
        // 2 非静默授权，第一次有弹框
        getCode(){ 
            this.code = ''
            var local = window.location.href // 获取页面url
            if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
              // 获取授权后的code位置
              var codeBeg = local.indexOf("?code=");
              var codeEnd = local.indexOf("#/?");
              // 截取授权后的code数据
              var codeCut = local.substring(codeBeg, codeEnd);
              local = local.replace(codeCut, "");
            }
            this.code = this.getUrlCode().code // 截取code
            if (!this.code) { // 如果没有code，则去请求
                window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${this.appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=${this.merchantId}&connect_redirect=1#wechat_redirect`
            } else {
              var merchantIdState = this.getUrlCode().state // 截取state
              if(null == merchantIdState || undefined == merchantIdState){
                merchantIdState = '';
              }
              if('' == this.merchantId && '' != merchantIdState){
                this.merchantId = merchantIdState;
                localStorage.setItem('cityMerchantId', this.merchantId);
              }
              // 通过code获取信息 
              this.fetch(this.code)
            }
        },
        //  code 登录
        async fetch(codeNum) {
                try {
                let info = { "appId": this.appid, "wxcode": codeNum }
                
                    localStorage.setItem('reToken', this.token)
                    
                    const res = await api.user.getwebLogin(info)
                    console.log(res,'登录接口')
                    if (res.code == "000000") { 
                        this.sign = res.data.sign;
                        this.mobile = res.data.mobile;
                        this.userId = res.data.userid;
                        this.openId = res.data.openid;
                        this.unionid = res.data.unionid;
                        localStorage.setItem('reSESSIONKEY', res.data.SESSIONKEY)
                        localStorage.setItem('codeSign', res.data.sign)
                        localStorage.setItem('unionid', res.data.unionid)
                        this.getList(res.data.sign)

                    } else {
                        if (res.code == '40163' || res.code == '40029') {
                          var local = window.location.href // 获取页面url
                          if(local.indexOf("?code=") != -1 && local.indexOf("#/?") != -1){
                            // 获取授权后的code位置
                            var codeBeg = local.indexOf("?code=");
                            var codeEnd = local.indexOf("#/?");
                            // 截取授权后的code数据
                            var codeCut = local.substring(codeBeg, codeEnd);
                            local = local.replace(codeCut, "");
                          }
                          // 重新访问 此路径地址
                          window.location.href = local;
                          // window.location.href = 'tigerCardLoginList.html#/'
                        }
                    }
                } catch (err) {
                    console.log(err)
                }
        },
        // 3 获取列表
        async getList (sign) {
          try {
              localStorage.setItem("reToken", this.token);
              let info  = {
                "cardRights": '4101', 
                "sign": sign, 
                "userid": 0,
                channel:'HUKA'
              }
              const res = await api.user.getcardWebLoginList(info)
              this.tigerList = res.data    
          } catch (error) {
              JmmToast(error)
          }
        },
        async cardLogin(cardRights,index) {
          try {
              localStorage.setItem("reToken", this.token);
              let info = {
                "cardRights": '4101', 
                "sign": this.sign, 
                "index": index,
                channel:'HUKA'
              }
              const res = await api.user.getwebLoginUpdateKey(info);
              if (res.code == '000000') {
                  let toUrl = `http://www.gonghuidefu.com/brandcoupon?unionid=${this.unionid}&sessionkey=${localStorage.getItem('reSESSIONKEY')}&cardrights=${cardRights}`
                  window.location.href = toUrl;
              }
          } catch (error) {
              console.log(err)
          }
        },
        cardBind:function(){ 
            if (this.mobile) {
                let toUrl = `tigerCardBind.html#/?merchantId=${this.merchantId}&channel=${this.channel}&sign=${this.sign}`
                window.location.href = toUrl;
            } else {
                let toUrl = `h5cardlogin.html#/?merchantId=${this.merchantId}&channel=${this.channel}&sign=${this.sign}&channel=HUKA`
                window.location.href = toUrl;
            }
            
        },
    },
  };
</script>

<style lang="stylus">
@import '../../assets/css/common.styl';
@import '../../assets/css/icon.css';
@import '../../assets/css/stylesheet.css';

.webcardloginMain_012 {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f5f5f5;
}

.webcardloginHead .headleft{
  float:left;
  text-align :left;
  width:70%;
  font-size :30px;
  height :50px;
}

.webcardloginHead .headright{
  float :right;
  text-align :right;
  width:30%;
  font-size :30px;
  height :50px;
}

.list_card_login_mine_012 ul {
   width: calc(100% - 40px);
   margin: 0 auto;
   color: #fff;

   li {
      width: 100%
      height 205px
      background: url('../../assets/img/images/bgCard.png') no-repeat center;
      background-size: cover;
      margin: 20px auto;
      border-radius: 15px;
      display flex
      align-items center

      .list_card_left,  .list_card_right {
         padding-left: 35px;
      }
      
     .list_card_right {
        h3 {
          font-size 33px
        }

        p {
          font-size 28px
        }
      }

      .list_card_left img {
        width: 100px;
        height: 100px;
      }
   }
}

.webbottom {
  position: fixed;
  bottom: 0px;
  background-color: #fff;
  width: 100%;
  height: 80px;
  text-align: center;
  display: flex;
  flex-direction: row;
}

.webbottom .item1 {
  width: 100%;
  background: #ff1734;
  float: left;
}

.webbottom .item1 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.webbottom .item2 {
  width: 50%;
  background: #999999;
  float: left;
}

.webbottom .item2 p {
  margin: 0;
  font-size: 28px;
  color: #fff;
  line-height: 80px;
}

.webbottomheight {
  height: 150px;
}


.center_box_list {
  font-size: 28px;
  font-family: Source Han Sans SC VF;
  text-align: center;
	border-radius: 20px;
	width: 80%;
	height: 350px;
	margin: auto;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}



</style>



// WEBPACK FOOTER //
// src/view/tigerCardLoginList/index.vue